import { createSelector } from 'reselect';
import { serviceProvider, serviceProviderPipelines } from './serviceProviderSelectors.js';
import pipelineFiltersSelector from '../screens/pipeline/redux/pipelineFiltersSelector.js';
import filterPipelineLeads from '../screens/pipeline/lib/filterPipeline.js';
import { getPipelineLeadSortedMeta } from '../lib/pipelineHelpers.js';
import { differenceInDays, parseISO } from 'date-fns';
import * as serviceProviderSelectors from './serviceProviderSelectors.js';
import cookPipelineLeads from '../lib/pipelineLeads/cookPipelineLeads.js';
import { query } from './querySelectors.js';
import todoIsOverdue from '../lib/todoIsOverdue.js';

const searchMemo = {};
const memoizeSearch = (id, lead) => {
  if (searchMemo[id]) {
    return searchMemo[id];
  }
  const result = [lead.business_name, lead.first_name, lead.last_name, ...(lead.contacts || []).map((n) => `${n.first_name || ''} ${n.last_name || ''}`)].map((n) => String(n || '').toLowerCase()).join(' ');
  searchMemo[id] = result;
  return result;
};

const stableObject = {};
const stableArray = [];

const leads = createSelector(serviceProviderSelectors.serviceProvider, (serviceProvider) => serviceProvider.leads);
export const pipelineLeads = createSelector(serviceProvider, leads, serviceProviderPipelines, (serviceProvider, leads, pipelines) => {
  const mappedLeads = serviceProvider.pipelineLeads.map((n) => {
    const lead = leads.find((l) => l.id === n.lead_id) || stableObject;
    let { sortedIncoming, sortedOutgoing } = getPipelineLeadSortedMeta(n, lead, true);
    return {
      ...n,
      computed: {
        lastActivityDays: Math.min(
          ...[...sortedOutgoing, ...sortedIncoming, { value: n.creation_datetime }]
            .filter((n) => n.value !== undefined)
            .map((n) => {
              return differenceInDays(new Date(), parseISO(n.value));
            })
        ),
        lastIncoming: (sortedIncoming[0] || {}).value,
        lastOutgoing: (sortedOutgoing[0] || {}).value,
        overdueTodos: (lead.todos || []).filter((n) => todoIsOverdue(n)).length,
        unreadMessages: parseFloat((lead.stats || {}).unread_incoming_messages || 0),
        searchString: memoizeSearch(lead.id, lead),
        leadMeta: lead.meta,
      },
      lead: undefined,
    };
  });
  return cookPipelineLeads(mappedLeads, pipelines);
});
export const pipelineLead = (pipelineLeadId) => createSelector(pipelineLeads, (pipelineLeads) => pipelineLeads.find((n) => n.id === pipelineLeadId));
export const pipelineActivePipelineId = (state) => state.router.location.pathname.split('/')[3];
export const pipelineActivePipeline = createSelector(pipelineActivePipelineId, serviceProviderPipelines, (pipelineId, pipelines) => pipelines.find((n) => n.id === pipelineId));
export const filteredPipelineLeads = createSelector(pipelineLeads, pipelineFiltersSelector, (pipelineLeads, filters) => {
  return filterPipelineLeads(pipelineLeads, filters);
});
export const leadModalActivePipelineLeadId = createSelector(query, (query) => query['pipelineLeadId']);
export const leadModalActivePipelineLead = createSelector(pipelineLeads, leadModalActivePipelineLeadId, (pipelineLeads, activePipelineLeadId) => pipelineLeads.find((n) => n.id === activePipelineLeadId));

export const pipelineDefaultWonStageId = createSelector(pipelineActivePipeline, (pipelineActivePipeline) => {
  return (pipelineActivePipeline || {}).default_won_stage;
});

export const pipelineScreen = (state) => state.pipelineScreen;
export const pipelineStageActions = (pipelineId, stageId) => createSelector(serviceProviderPipelines, (state) => ((((state.find(n => n.id === pipelineId) || stableObject).stages || stableArray).find(n => n.id === stageId) || stableObject).actions || stableArray));
export const pipelineStagesById = (pipelineId) => createSelector(serviceProviderPipelines, (state) => (((state || []).find(n => n.id === pipelineId) || stableObject).stages || stableArray))
export const pipelineLeadActionById = (pipelineLeadId, actionId) => createSelector(pipelineScreen, (state) => { return (state.actions[pipelineLeadId] || stableObject)[actionId] || stableObject });